import { render, staticRenderFns } from "./ExpireTotal.vue?vue&type=template&id=50b067ca&scoped=true&"
import script from "./ExpireTotal.vue?vue&type=script&lang=js&"
export * from "./ExpireTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b067ca",
  null
  
)

export default component.exports